import React, { useState, useEffect } from "react";
import "./info.css";

function Info({ title, htmlFileName }) {
    const [htmlContent, setHtmlContent] = useState('');
    
        useEffect(() => {
            fetch(htmlFileName)
            .then(res => res.text())
            .then(setHtmlContent);
        }, []);
     
    return (
        <section
        className="info"
        >
        <div className="info-content">
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>     
    </section>
    );
}

export default Info;